import {
  ApiApplicationBaseInfo,
  ApplicationBaseInfo,
  mapApplicationBaseInfo
} from '../index'
import { ThisConnector } from '../../../api/connector'

export interface GetApplicationsBaseInfoArgs {
  organizationUuid: string
}

export interface GetApplicationsBaseInfoResponse {
  applications: ApiApplicationBaseInfo[]
}

export async function getApplicationsBaseInfo(
  this: ThisConnector,
  { organizationUuid }: GetApplicationsBaseInfoArgs
): Promise<ApplicationBaseInfo[]> {
  const { applications } =
    await this.connector.get<GetApplicationsBaseInfoResponse>(
      `/${organizationUuid}/applications/filter/info?includeArchived=false&includeMerged=false&includeOnlyLicensed=true`
    )
  return applications.map(mapApplicationBaseInfo)
}
